import React, { FC, useState, useEffect } from 'react';
import { RufasInputsControlDefinition } from '../services/layout';
import { useDataValue } from '../utils';
import { FormControlProps } from "../utils";
import { FormControl } from './FormControl';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import config from "../../../../config";

export interface RufasInputsProps extends FormControlProps<RufasInputsControlDefinition> {
}

const useStyles = makeStyles(function(theme: Theme) {
  return createStyles({
    text: function() {
      return {
        padding: '12px',
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.primary
      }
    }
  })
});

export const RufasInputs: FC<any> = function(props) {

  const module = props.module;
  const evaluation = useDataValue('{}') as any;
  const [text, setText] = useState('');

  useEffect(function updateFromSource() {
    let url = `${config.rumen}/`;
    if (module) {
      url += module;
    }
    fetch(url, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(evaluation),
      mode: 'cors'
    })
    .then(res => {
      return res.json();
    })
    .then(data => {
      setText('' + ((evaluation !== undefined && evaluation !== null) ? JSON.stringify(data, null, 2) : ''));
    });
    
  }, [evaluation]);

  const classes = useStyles();

  return <FormControl>
      <div className = { classes.text }>
        <pre>{ text }</pre>
      </div>
    </FormControl>;
};